import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import {
  GET_SUBJECTS_EXTRA_CUR_EDU_LIST,
  GET_SUBJECTS_EXTRA_CUR_EDU_ITEM
} from "./types";





// <----  ПРЕДМЕТЫ ДО ---->

export const getSubjectsExtraCurEdu = (status) => async (dispatch, getState) => {
  try {
    const urlParams = status.status !== "Идет" ? '' : new URLSearchParams(status).toString();
    const { data } = await api.get(`/out_courses?${urlParams}`);
    dispatch({ type: GET_SUBJECTS_EXTRA_CUR_EDU_LIST, payload: data });
  } catch (error) {
    console.error('Error in directoryExtraCurEducation action:', error);
  }
};

export const getSubjectsExtraCurEduById = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/out_courses/${id} `);
    dispatch({ type: GET_SUBJECTS_EXTRA_CUR_EDU_ITEM, payload: data });
  } catch (error) {
    console.error('Error in directoryExtraCurEducation action:', error);
  }
};

export const updateSubjectsExtraCurEdu = (params, status) => async (dispatch, getState) => {
  try {
    await api.put(`/out_courses/${params.xp_key}`, params);
    await dispatch(getSubjectsExtraCurEdu(status));
  } catch (error) {
    console.error('Error in directoryExtraCurEducation action:', error);
  }
}

export const createSubjectsExtraCurEdu = (data, status) => async (dispatch, getState) => {
  try {
    await api.post(`/out_courses`, data);
    createNotification('success', 'Успешно');
    await dispatch(getSubjectsExtraCurEdu(status));
  } catch (error) {
    console.error('Error in directoryExtraCurEducation action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteSubjectsExtraCurEdu = (id, status) => async (dispatch, getState) => {
  try {
    await api.delete(`/out_courses/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getSubjectsExtraCurEdu(status));
  } catch (error) {
    console.error('Error in directoryExtraCurEducation action:', error);
    createNotification('error', error.message || 'Произошла ошибка');
  }
};
